// export const getColumnPinningStyles = (column) => {
//   const isPinned = column?.getIsPinned();
//   const isLastLeftPinnedColumn =
//     isPinned === "left" && column?.getIsLastColumn("left");
//   const isFirstRightPinnedColumn =
//     isPinned === "right" && column?.getIsFirstColumn("right");

//   return {
//     boxShadow: isLastLeftPinnedColumn
//       ? "-4px 0 4px -4px gray inset"
//       : isFirstRightPinnedColumn
//       ? "4px 0 4px -4px gray inset"
//       : undefined,
//     background: isPinned ? "#1a1b1e" : undefined,
//     left: isPinned === "left" ? `${column?.getStart("left")}px` : undefined,
//     right: isPinned === "right" ? `${column?.getAfter("right")}px` : undefined,
//     opacity: isPinned ? 0.95 : 1,
//     position: isPinned ? "sticky" : "relative",
//     width: column?.getSize(),
//     zIndex: isPinned ? 1 : 0,
//   };
// };

// export const getColumnPinningStylesBody = (column) => {
//   const isPinned = column?.getIsPinned();
//   const isLastLeftPinnedColumn =
//     isPinned === "left" && column?.getIsLastColumn("left");
//   const isFirstRightPinnedColumn =
//     isPinned === "right" && column?.getIsFirstColumn("right");

//   return {
//     boxShadow: isLastLeftPinnedColumn
//       ? "-4px 0 4px -4px gray inset"
//       : isFirstRightPinnedColumn
//       ? "4px 0 4px -4px gray inset"
//       : undefined,
//     background: isPinned ? "#2c2d31" : undefined,
//     left: isPinned === "left" ? `${column?.getStart("left")}px` : undefined,
//     right: isPinned === "right" ? `${column?.getAfter("right")}px` : undefined,
//     opacity: isPinned ? 0.95 : 1,
//     position: isPinned ? "sticky" : "relative",
//     width: column?.getSize(),
//     zIndex: isPinned ? 1 : 0,
//   };
// };


// working pinning

export const getColumnPinningStyles = (column) => {
  const isPinned = column?.is_pinned; // Assuming the API response contains an "is_pinned" property
  const isLastLeftPinnedColumn =
    isPinned === "left" && column?.is_pinned("left"); // Check if the column is the first pinned column
  const isFirstRightPinnedColumn =
    isPinned === "right" && column?.is_pinned("right"); // Check if the column is the last pinned column

  return {
    boxShadow: isLastLeftPinnedColumn
      ? "-4px 0 4px -4px gray inset"
      : isFirstRightPinnedColumn
      ? "4px 0 4px -4px gray inset"
      : undefined,
    background: isPinned ? "#2c2d31" : undefined,
    left: isPinned === "left" ? `${column?.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column?.getAfter("right")}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned ? "sticky" : "relative",
    width: column?.getSize(),
    zIndex: isPinned ? 1 : 0,
  };
};

export const getColumnPinningStylesBody = (column) => {
  const isPinned = column?.is_pinned; // Assuming the API response contains an "is_pinned" property
  const isLastLeftPinnedColumn =
    isPinned === "left" && column?.is_pinned("left"); // Check if the column is the first pinned column
  const isFirstRightPinnedColumn =
    isPinned === "right" && column?.is_pinned("right"); // Check if the column is the last pinned column

  return {
    boxShadow: isLastLeftPinnedColumn
      ? "-4px 0 4px -4px gray inset"
      : isFirstRightPinnedColumn
      ? "4px 0 4px -4px gray inset"
      : undefined,
    background: isPinned ? "#2c2d31" : undefined,
    left: isPinned === "left" ? `${column?.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column?.getAfter("right")}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned ? "sticky" : "relative",
    width: column?.width,
    zIndex: isPinned ? 1 : 0,
  };
};


// export const getColumnPinningStyles = (column) => {
//   const isSourceRefNo = column?.attribute_key === "src_source_ref_no"; // Check if the column is "SOURCE REF. NO."

//   return {
//     boxShadow: isSourceRefNo ? "4px 0 4px -4px gray inset" : undefined, // Apply boxShadow to the right of the "SOURCE REF. NO." column
//     background: isSourceRefNo ? "#2c2d31" : undefined,
//     left: isSourceRefNo ? 0 : undefined,
//     right: isSourceRefNo ? "auto" : undefined,
//     opacity: isSourceRefNo ? 0.95 : 1,
//     position: isSourceRefNo ? "sticky" : "relative",
//     width: isSourceRefNo ? column?.width : "auto", // Set width for the "SOURCE REF. NO." column only
//     zIndex: isSourceRefNo ? 1 : undefined,
//   };
// };

// export const getColumnPinningStylesBody = (column) => {
//   const isSourceRefNo = column?.attribute_key === "src_source_ref_no"; // Check if the column is "SOURCE REF. NO."

//   return {
//     boxShadow: isSourceRefNo ? "4px 0 4px -4px gray inset" : undefined, // Apply boxShadow to the right of the "SOURCE REF. NO." column
//     background: isSourceRefNo ? "#2c2d31" : undefined,
//     left: isSourceRefNo ? 0 : undefined,
//     right: isSourceRefNo ? "auto" : undefined,
//     opacity: isSourceRefNo ? 0.95 : 1,
//     position: isSourceRefNo ? "sticky" : "relative",
//     width: isSourceRefNo ? column?.width : "auto", // Set width for the "SOURCE REF. NO." column only
//     zIndex: isSourceRefNo ? 1 : undefined,
//   };
// };




export const getColumnJustifyContent = (alignment) => {
  if (alignment === "left") {
    return "flex-start";
  } else if (alignment === "right") {
    return "flex-end";
  } else if (alignment === "center") {
    return "center";
  }
};
